export const createValidationRules = (setters) => ({
  siteName: {
    maxLength: 40,
    errorMsg: "Cannot exceed 40 characters.",
    setter: setters.setSiteNameValid,
  },
  territory: {
    requiredLength: 6,
    errorMsg: "Please enter 6 digits",
    setter: setters.setTerrValid,
  },
  siteStreet: {
    maxLength: 100,
    errorMsg: "Cannot exceed 100 characters.",
    setter: setters.setSiteStreetValid,
  },
  siteCity: {
    maxLength: 50,
    errorMsg: "Cannot exceed 50 characters.",
    setter: setters.setSiteCityValid,
  },
  siteZip: {
    maxLength: 10,
    errorMsg: "Cannot exceed 10 characters.",
    setter: setters.setSiteZipValid,
  },
  parentName: {
    maxLength: 100,
    errorMsg: "Cannot exceed 100 characters.",
    setter: setters.setParentNameValid,
  },
});
